// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__11SPd","question":"Question_question__12syI","description":"Question_description__3TIJu"};